// src/utils/medications.js
import { loadCSVList } from "./csvLoader";
export const loadMedications = () =>
  loadCSVList("/data/clean/medications.csv", { unique: true, sort: true, normalize: true });

